import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import LibrarySelector from './LibrarySelector';
import {Link as _RouterLink} from 'react-router-dom';
import 'bf-school.svg';
import {
  BoxedInputWrapper,
  BoxedSearch,
  colors,
  StyledIconToggle,
  ToolBar,
  ToolBarType,
  ValidationDecorationBorder
} from '@bettermarks/bm-ui-components';
import {
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Box,
  Text,
  VStack,
  HStack,
  useColorMode,
  useColorModeValue,
  Icon,
  Link,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  IconButton,
  Button,
  Avatar,
  WrapItem
} from '@chakra-ui/react';

import {FiSearch, FiChevronDown} from 'react-icons/fi';

import {useRoutes} from '../services/route.service';
import {handleAlertMessage} from '../helpers/Alert';
import {FakeSearch} from './Fake';
import {useStorage} from '../services/pt-storage.service';
import {ArrowBack, WhiteboardIcon} from './Icons';
import {Knob, KnobSize, KnobType, KnobVariant} from './Knob';

const LibrarySearch = styled(BoxedSearch)`
  &,
  ${BoxedInputWrapper} {
    height: 40px;
  }
  ${ValidationDecorationBorder} {
    border-radius: 20px;
  }
  input {
    padding-top: 12px;
  }
  ${StyledIconToggle} {
    height: 40px;
    width: 40px;
  }
`;

const MyToolBar = styled(ToolBar)`
  background: ${colors.cWhite};
  border-bottom: 1px solid rgb(153, 153, 153);
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const SearchBar: React.FC<{
  isSelectionPage?: boolean;
  libraryName?: string;
}> = ({isSelectionPage, libraryName}) => {
  const RouteService = useRoutes();
  const StorageService = useStorage();
  const [librarySelectionLink, setLibSelection] = useState<string>('');

  useEffect(() => {
    setLibSelection(RouteService.librarySelection(StorageService.getVersion()));
  }, [libraryName, isSelectionPage]);
  return (
    <>
      <Flex
        backdropFilter='auto'
        backdropBlur='18px'
        zIndex={1}
        position='sticky'
        mx='32px'
        top={0}
      >
        <Flex
          justifyContent='space-between'
          flex={1}
          p='16px 0'
          borderBottom='1px solid #ccc'
        >
          {!isSelectionPage && libraryName ? (
            <>
              <Flex flexDir='column' alignItems='flex-start' gap='8px' flex={1}>
                <Flex flex={1} width='100%' padding='16px 0'>
                  <Button
                    aria-label='Zurück'
                    size='md'
                    as={_RouterLink}
                    variant='link'
                    fontSize='16px'
                    fontWeight={600}
                    color='gray.600'
                    gap='8px'
                    to={librarySelectionLink}
                  >
                    <ArrowBack />
                    Zurück
                  </Button>
                </Flex>
                <Flex flex={1} width='100%'>
                  <HStack>
                    <Link
                      fontSize='14px'
                      as={_RouterLink}
                      to='/library--select--v2'
                    >
                      Inhalte /
                    </Link>
                  </HStack>
                </Flex>
                <Flex flex={1} width='100%' justifyContent='space-between'>
                  <Link
                    fontSize='20px'
                    lineHeight='120%'
                    fontWeight={600}
                    variant='link'
                    as={_RouterLink}
                    to={''}
                  >
                    {libraryName}
                  </Link>
                  <InputGroup width='auto'>
                    <InputLeftElement
                      height='32px'
                      pointerEvents='none'
                      children={<Icon fontSize='20' as={FiSearch} />}
                    />
                    <Input
                      variant='filled'
                      size='sm'
                      type='tel'
                      placeholder='Inhalte durchsuchen...'
                      borderRadius='6px'
                      borderWidth='1px'
                      borderColor='gray.300'
                    />
                  </InputGroup>
                </Flex>
              </Flex>
            </>
          ) : (
            ' '
          )}
        </Flex>
      </Flex>
    </>
  );
};
